import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.css';
import './NotFoundPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import logo from '../../assets/img/logotipo.png';

export default function NotFoundPage(){
  const navigate = useNavigate();

  return (
    <div className="NotFound-container">
        <Header/>
        
        <article>
          <div className="NotFound">
            <img src={logo} alt="Logotipo" className="NotFound-logo" />

            <h1 className="NotFound-title">Página não encontrada</h1>
            
            <p className="NotFound-text">
              A página que você tentou acessar não existe ou foi movida.
            </p>

            <button 
              className="NotFound-button" 
              onClick={() => navigate(-1)}
            >
              Voltar
            </button>
          </div>
        </article>

        <Footer />     
    </div>
  );  
}